export const RESET = 'EXSBWAREHOUSETYPE_LIST_RESET'
export const SET_ITEMS = 'EXSBWAREHOUSETYPE_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBWAREHOUSETYPE_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBWAREHOUSETYPE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBWAREHOUSETYPE_LIST_TOGGLE_LOADING'
